import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import PropTypes from "prop-types";

import { useSelector } from "react-redux";

import { TableRowWrapper } from "../Table/styled";
import { DraggingRow } from "./styled";

const DraggableTableRow = ({ row, customCellProps = {}, onRowClick, cellRefs, rowIndex }) => {
  const createdTableRowsIds = useSelector((store) => store.global.createdTableRowsIds);

  const { attributes, listeners, transform, transition, setNodeRef, isDragging } = useSortable({
    id: row.original.id
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition
  };

  const draggingRowProps = { ...attributes, ...listeners };

  return (
    <TableRowWrapper
      ref={setNodeRef}
      style={style}
      {...row.getRowProps()}
      onClick={() => {
        onRowClick != undefined && onRowClick(row?.original);
      }}
      isRecentlyCreated={createdTableRowsIds.includes(row.original.id)}>
      {isDragging && !customCellProps.isLoading ? (
        <DraggingRow colSpan={row.cells.length}>&nbsp;</DraggingRow>
      ) : (
        row.cells.map((cell, index) => {
          return (
            <td
              key={index}
              {...cell.getCellProps()}
              ref={(ref) => (rowIndex === 0 ? (cellRefs.current[index] = ref) : null)}>
              {cell.render("Cell", { ...customCellProps, draggingRowProps })}
            </td>
          );
        })
      )}
    </TableRowWrapper>
  );
};

DraggableTableRow.propTypes = {
  row: PropTypes.shape({
    getRowProps: PropTypes.func,
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    }).isRequired,
    cells: PropTypes.arrayOf(
      PropTypes.shape({
        getCellProps: PropTypes.func.isRequired,
        render: PropTypes.func
      })
    )
  }),
  customCellProps: PropTypes.object,
  onRowClick: PropTypes.func,
  cellRefs: PropTypes.object,
  rowIndex: PropTypes.number
};

export default DraggableTableRow;
